(function () {
  function initCarousel(root, options) {
    var viewport = root.querySelector(options.viewport);
    var track = root.querySelector(options.track);
    var items = root.querySelectorAll(options.item);
    var prevBtn = root.querySelector(options.prev);
    var nextBtn = root.querySelector(options.next);

    if (!viewport || !track || items.length <= 1) return;

    var currentIndex = 0;

    function getMaxIndex() {
      return Math.max(0, items.length - 1);
    }

    function updateButtons() {
      var maxIndex = getMaxIndex();
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    function scrollToIndex(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      var item = items[currentIndex];
      if (!item) return;

      viewport.scrollTo({
        left: item.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });

      updateButtons();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(currentIndex + 1);
      });
    }

    var scrollTicking = false;

    viewport.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          scrollTicking = false;
          var scrollLeft = viewport.scrollLeft;
          var nearestIndex = 0;
          var nearestDistance = Infinity;

          items.forEach(function (item, index) {
            var distance = Math.abs(item.offsetLeft - track.offsetLeft - scrollLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          currentIndex = Math.min(nearestIndex, getMaxIndex());
          updateButtons();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
  }

  document.querySelectorAll('[data-about-philosophy-carousel]').forEach(function (carousel) {
    initCarousel(carousel, {
      viewport: '[data-about-philosophy-viewport]',
      track: '[data-about-philosophy-track]',
      item: '[data-about-philosophy-slide]',
      prev: '[data-about-philosophy-prev]',
      next: '[data-about-philosophy-next]',
    });
  });

  function initTimelineHighlight(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-about-timeline-item]'));
    if (!items.length) return;

    function setActive(activeIndex) {
      items.forEach(function (item, index) {
        var isActive = index === activeIndex;
        item.classList.toggle('rabitat-about-us__timeline-item--active', isActive);
        item.classList.toggle('rabitat-about-us__timeline-item--muted', !isActive);
      });
    }

    function updateActive() {
      var triggerY = window.innerHeight * 0.42;
      var activeIndex = 0;

      items.forEach(function (item, index) {
        var rect = item.getBoundingClientRect();
        if (rect.top <= triggerY) {
          activeIndex = index;
        }
      });

      setActive(activeIndex);
    }

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateActive();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateActive();
  }

  document.querySelectorAll('[data-about-timeline]').forEach(initTimelineHighlight);
})();
